export const footerMoreLinks = {
  'lb-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://lb.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://lb.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },

        {
          href: 'https://lb.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://lb.wingie.com/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://lb.wingie.com/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://lb.wingie.com/de/awards/',
          title: 'Unsere Preise',
        },
      ],
    },
  ],
  'lb-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://lb.wingie.com/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://lb.wingie.com/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://lb.wingie.com/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://lb.wingie.com/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://lb.wingie.com/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://lb.wingie.com/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'lb-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://lb.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://lb.wingie.com/en/faq/',
          title: 'Frequently Asked Questions',
        },
        {
          href: 'https://lb.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://lb.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://lb.wingie.com/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://lb.wingie.com/en/awards/',
          title: 'Awards',
        },
      ],
    },
  ],
  'lb-ru': [
    {
      title: 'Больше',
      items: [
        {
          href: 'https://lb.wingie.com/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://lb.wingie.com/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },
        {
          href: 'https://lb.wingie.com/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://lb.wingie.com/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://lb.wingie.com/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://lb.wingie.com/ru/awards/',
          title: 'Награды',
        },
      ],
    },
  ],
  'lb-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://lb.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://lb.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },
        {
          href: 'https://lb.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://lb.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://lb.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://lb.wingie.com/es/awards/',
          title: 'Premios',
        },
      ],
    },
  ],
  'lb-it': [
    {
      title: 'Altro',
      items: [
        {
          href: 'https://lb.wingie.com/it/contact/',
          title: 'Contatto',
        },
        // {
        //     href: 'https://lb.wingie.com/it/faq/',
        //     title: 'Domande Frequenti',
        // },
        {
          href: 'https://lb.wingie.com/it/about-us/',
          title: 'Chi siamo',
        },
        {
          href: 'https://lb.wingie.com/it/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://lb.wingie.com/it/terms-and-conditions/',
          title: 'Termini e Condizioni',
        },
        {
          href: 'https://lb.wingie.com/it/awards/',
          title: 'Premi',
        },
      ],
    },
  ],
  'lb-fr': [
    {
      title: 'Plus',
      items: [
        {
          href: 'https://lb.wingie.com/fr/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://lb.wingie.com/fr/faq/',
        //     title: 'Questions Fréquemment Posées',
        // },
        {
          href: 'https://lb.wingie.com/fr/about-us/',
          title: 'À propos de nous',
        },
        {
          href: 'https://lb.wingie.com/fr/privacy/',
          title: 'Confidentialité',
        },
        {
          href: 'https://lb.wingie.com/fr/terms-and-conditions/',
          title: 'Termes et Conditions',
        },
        {
          href: 'https://lb.wingie.com/fr/awards/',
          title: 'Prix',
        },
      ],
    },
  ],
  'lb-pt': [
    {
      title: 'Mais',
      items: [
        {
          href: 'https://lb.wingie.com/pt/contact/',
          title: 'Contacto',
        },
        // {
        //     href: 'https://lb.wingie.com/pt/faq/',
        //     title: 'Perguntas Frequentes',
        // },
        {
          href: 'https://lb.wingie.com/pt/about-us/',
          title: 'Sobre nós',
        },
        {
          href: 'https://lb.wingie.com/pt/privacy/',
          title: 'Privacidade',
        },
        {
          href: 'https://lb.wingie.com/pt/terms-and-conditions/',
          title: 'Termos e Condições',
        },
        {
          href: 'https://lb.wingie.com/pt/awards/',
          title: 'Prémios',
        },
      ],
    },
  ],
  'lb-ro': [
    {
      title: 'Mai Mult',
      items: [
        {
          href: 'https://lb.wingie.com/ro/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://lb.wingie.com/ro/faq/',
        //     title: 'Întrebări Frecvente',
        // },
        {
          href: 'https://lb.wingie.com/ro/about-us/',
          title: 'Despre noi',
        },
        {
          href: 'https://lb.wingie.com/ro/privacy/',
          title: 'Confidențialitate',
        },
        {
          href: 'https://lb.wingie.com/ro/terms-and-conditions/',
          title: 'Termeni și Condiții',
        },
        {
          href: 'https://lb.wingie.com/ro/awards/',
          title: 'Premii',
        },
      ],
    },
  ],
  'lb-pl': [
    {
      title: 'Więcej',
      items: [
        {
          href: 'https://lb.wingie.com/pl/contact/',
          title: 'Kontakt',
        },
        // {
        //     href: 'https://lb.wingie.com/pl/faq/',
        //     title: 'Często Zadawane Pytania',
        // },
        {
          href: 'https://lb.wingie.com/pl/about-us/',
          title: 'O nas',
        },
        {
          href: 'https://lb.wingie.com/pl/privacy/',
          title: 'Prywatność',
        },
        {
          href: 'https://lb.wingie.com/pl/terms-and-conditions/',
          title: 'Regulamin',
        },
        {
          href: 'https://lb.wingie.com/pl/awards/',
          title: 'Nagrody',
        },
      ],
    },
  ],
  'lb-lt': [
    {
      title: 'Daugiau',
      items: [
        {
          href: 'https://lb.wingie.com/lt/contact/',
          title: 'Kontaktai',
        },
        // {
        //     href: 'https://lb.wingie.com/lt/faq/',
        //     title: 'Dažnai Užduodami Klausimai',
        // },
        {
          href: 'https://lb.wingie.com/lt/about-us/',
          title: 'Apie mus',
        },
        {
          href: 'https://lb.wingie.com/lt/privacy/',
          title: 'Privatumas',
        },
        {
          href: 'https://lb.wingie.com/lt/terms-and-conditions/',
          title: 'Taisyklės ir Sąlygos',
        },
        {
          href: 'https://lb.wingie.com/lt/awards/',
          title: 'Prizai',
        },
      ],
    },
  ],
  'lb-uz': [
    {
      title: "Ko'proq",
      items: [
        {
          href: 'https://lb.wingie.com/uz/contact/',
          title: 'Aloqa',
        },
        // {
        //     href: 'https://lb.wingie.com/uz/faq/',
        //     title: 'Tez-tez Beriladigan Savollar',
        // }
        {
          href: 'https://lb.wingie.com/uz/about-us/',
          title: 'Biz haqimizda',
        },
        {
          href: 'https://lb.wingie.com/uz/privacy/',
          title: 'Maxfiylik',
        },
        {
          href: 'https://lb.wingie.com/uz/terms-and-conditions/',
          title: 'Shartlar va Qoidalar',
        },
        {
          href: 'https://lb.wingie.com/uz/awards/',
          title: 'Mukofotlar',
        },
      ],
    },
  ],
  'lb-sr': [
    {
      title: 'Више',
      items: [
        {
          href: 'https://lb.wingie.com/sr/contact/',
          title: 'Контакт',
        },
        // {
        //     href: 'https://lb.wingie.com/sr/faq/',
        //     title: 'Честа питања',
        // },
        {
          href: 'https://lb.wingie.com/sr/about-us/',
          title: 'О нама',
        },
        {
          href: 'https://lb.wingie.com/sr/privacy/',
          title: 'Приватност',
        },
        {
          href: 'https://lb.wingie.com/sr/terms-and-conditions/',
          title: 'Услови коришћења',
        },
        {
          href: 'https://lb.wingie.com/sr/awards/',
          title: 'Награде',
        },
      ],
    },
  ],
  'lb-ky': [
    {
      title: 'Дагы',
      items: [
        {
          href: 'https://lb.wingie.com/ky/contact/',
          title: 'Байланыш',
        },
        // {
        //     href: 'https://lb.wingie.com/ky/faq/',
        //     title: 'Жыйнак суроолор',
        // },
        {
          href: 'https://lb.wingie.com/ky/about-us/',
          title: 'Биз жөнүндө',
        },
        {
          href: 'https://lb.wingie.com/ky/privacy/',
          title: 'Купуялуулук',
        },
        {
          href: 'https://lb.wingie.com/ky/terms-and-conditions/',
          title: 'Шарттар жана Талаптар',
        },
        {
          href: 'https://lb.wingie.com/ky/awards/',
          title: 'Мурадлар',
        },
      ],
    },
  ],
  'lb-tg': [
    {
      title: 'Бештар',
      items: [
        {
          href: 'https://lb.wingie.com/tg/contact/',
          title: 'Тамос',
        },
        // {
        //     href: 'https://lb.wingie.com/tg/faq/',
        //     title: 'Саволҳои зиёд',
        // },
        {
          href: 'https://lb.wingie.com/tg/about-us/',
          title: 'Дар бораи мо',
        },
        {
          href: 'https://lb.wingie.com/tg/privacy/',
          title: 'Махфият',
        },
        {
          href: 'https://lb.wingie.com/tg/terms-and-conditions/',
          title: 'Шартҳо ва шароитҳо',
        },
        {
          href: 'https://lb.wingie.com/tg/awards/',
          title: 'Мурадлар',
        },
      ],
    },
  ],
  'lb-kk': [
    {
      title: 'Көбірек',
      items: [
        {
          href: 'https://lb.wingie.com/kk/contact/',
          title: 'Байланыс',
        },
        // {
        //     href: 'https://lb.wingie.com/kk/faq/',
        //     title: 'Жиі қойылатын сұрақтар',
        // },
        {
          href: 'https://lb.wingie.com/kk/about-us/',
          title: 'Біз туралы',
        },
        {
          href: 'https://lb.wingie.com/kk/privacy/',
          title: 'Құпиялылық',
        },
        {
          href: 'https://lb.wingie.com/kk/terms-and-conditions/',
          title: 'Шарттар мен ережелер',
        },
        {
          href: 'https://lb.wingie.com/kk/awards/',
          title: 'Біздің марапаттарымыз',
        },
      ],
    },
  ],
  'lb-nl': [
    {
      title: 'Meer',
      items: [
        {
          href: 'https://lb.wingie.com/nl/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://lb.wingie.com/nl/faq/',
        //     title: 'Veelgestelde Vragen',
        // },
        {
          href: 'https://lb.wingie.com/nl/about-us/',
          title: 'Over ons',
        },
        {
          href: 'https://lb.wingie.com/nl/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://lb.wingie.com/nl/terms-and-conditions/',
          title: 'Voorwaarden',
        },
        {
          href: 'https://lb.wingie.com/nl/awards/',
          title: 'Onze prijzen',
        },
      ],
    },
  ],
  'lb-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://lb.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://lb.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://lb.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://lb.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://lb.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://lb.wingie.com/ja/awards/' },
      ],
    },
  ],
  'lb-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://lb.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://lb.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://lb.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://lb.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://lb.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://lb.wingie.com/zh/awards/' },
      ],
    },
  ],
  'lb-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://lb.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://lb.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://lb.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://lb.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://lb.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://lb.wingie.com/ko/awards/' },
      ],
    },
  ],
  'lb-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://lb.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://lb.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://lb.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://lb.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://lb.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://lb.wingie.com/hi/awards/' },
      ],
    },
  ],
  'lb-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://lb.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://lb.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://lb.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://lb.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://lb.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://lb.wingie.com/ta/awards/' },
      ],
    },
  ],
  'lb-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://lb.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://lb.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://lb.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://lb.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://lb.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://lb.wingie.com/th/awards/' },
      ],
    },
  ],
  'lb-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://lb.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://lb.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://lb.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://lb.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://lb.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://lb.wingie.com/ur/awards/' },
      ],
    },
  ],
  'lb-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://lb.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://lb.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://lb.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://lb.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://lb.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://lb.wingie.com/ka/awards/' },
      ],
    },
  ],
}
